module.exports = __webpack_public_path__ + "static/media/shape2_2.ab5c7584.obj";